import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface editProfileFields {
    name?: string;
    email?: string;
    mobile?: string;
    password?: string;
}

// Edit profile state
export interface editProfileState {
    fields: editProfileFields,
    isLoading: boolean,
    isLoaded: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialEditProfileState: editProfileState = {
    fields: {},
    isLoading: true,
    isLoaded: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const editProfileSlice = createSlice({
    name: 'edit_profile',
    initialState: initialEditProfileState,
    reducers: {
        init: state => initialEditProfileState,
        set: ( state, {payload}: PayloadAction<editProfileFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
            state.isLoading = false
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})